module.exports = __webpack_public_path__ + "c8cfd48ec43b2b74c12ce839c1d6c2ed.jpg";